import connect from 'react-redux/es/connect/connect';
import { setCardToken } from '../actions/user';
import PaymentCardForm from '../components/paymentform/PaymentCardForm';

const mapStateToProps = state => ({
    customer: state.user.customer
});

const mapDispatchToProps = dispatch => ({
    setToken: token => {
        dispatch(setCardToken(token));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentCardForm);
